import 'globals';

window.pageLoadedQueue = [];

(function($, window, document, pageLoadedQueue) {
	var neosPageLoaded = false,
		init = function() {
			$.each(pageLoadedQueue, function(i, val) {
				val();
			});
		};

	document.addEventListener('Neos.PageLoaded', function() {
		neosPageLoaded = true;
		init();
	}, false);

	$(function(){
		if (!neosPageLoaded) {
			init();
		}
	});
})(jQuery, window, document, window.pageLoadedQueue);
